import React from 'react'
import AdminVehicles from '../../components/admin/vehicles/admin-vehicles'
import AdminTemplate from '../../templates/admin-template'


const AdminVehiclesPage = () => {
  return (
    <AdminTemplate>
        <AdminVehicles/>
    </AdminTemplate>
  )
}

export default AdminVehiclesPage